const Style = {

  // The gradient is applied inline (see onboarding.js) so it can follow the form's
  // theme; only the layout classes live here.
  onboarding: 'flex items-center justify-center min-h-full text-left'

}

export default Style;
